module.exports = __webpack_public_path__ + "img/part-three-thumb.5ea1a45.jpg";